import type { ModuleNav } from '@saas/ui';

export const SURVEY_ADMIN_ROLES = ['owner', 'admin'];
/** 作成・下書きの編集 */
export const SURVEY_WRITE_PERMISSIONS = ['survey.survey.write.own', 'survey.survey.write.all'];
/** 公開・締切・公開後の編集 */
export const SURVEY_MANAGE_PERMISSIONS = ['survey.survey.manage.own', 'survey.survey.manage.all'];
/** 「作成した調査」の一覧・詳細が見られる人（read / write / manage のどれか） */
export const SURVEY_READ_PERMISSIONS = ['survey.survey.read.own', 'survey.survey.read.team', 'survey.survey.read.all', ...SURVEY_WRITE_PERMISSIONS, ...SURVEY_MANAGE_PERMISSIONS];

/** apps/web のシェルが集約する。登録はリードが行う（apps/web/src/app/shell/nav.ts） */
export const surveyNav: ModuleNav = {
  module: 'survey',
  items: [
    { label: '社外フォーム', to: '/survey/forms', icon: 'assignment', permission: SURVEY_READ_PERMISSIONS, description: '社外のテスト・アンケート・データ受付' },
    { label: 'アンケート・テスト', to: '/survey', icon: 'assignment', end: true, description: '自分宛ての回答と作成した調査' },
    { label: 'フォームを作成', to: '/survey/create', icon: 'add', permission: SURVEY_WRITE_PERMISSIONS, description: '社内外のアンケート・テスト・データ受付を作る' },
  ],
  admin: [],
};
